import { render, staticRenderFns } from "./ReviewImport.vue?vue&type=template&id=05da0ec5"
import script from "./ReviewImport.vue?vue&type=script&lang=js"
export * from "./ReviewImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports